import { __read, __spreadArray } from "tslib";
import { useRef, useCallback, useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useDebouncedCallback(callback, delay, 
// eslint-disable-next-line @typescript-eslint/member-delimiter-style
options) {
    if (options === void 0) { options = {}; }
    var maxWait = options.maxWait;
    var maxWaitHandler = useRef(0);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var maxWaitArgs = useRef([]);
    var leading = options.leading;
    var wasLeadingCalled = useRef(false);
    var functionTimeoutHandler = useRef(0);
    var isComponentUnmounted = useRef(false);
    var debouncedFunction = useRef(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = useCallback(function () {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = 0;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = 0;
        wasLeadingCalled.current = false;
    }, []);
    useEffect(function () { return function () {
        // we use flag, as we allow to call callPending outside the hook
        isComponentUnmounted.current = true;
    }; }, []);
    var debouncedCallback = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (!functionTimeoutHandler.current &&
            leading &&
            !wasLeadingCalled.current) {
            debouncedFunction.current.apply(debouncedFunction, __spreadArray([], __read(args)));
            wasLeadingCalled.current = true;
            return;
        }
        functionTimeoutHandler.current = window.setTimeout(function () {
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) {
                debouncedFunction.current.apply(debouncedFunction, __spreadArray([], __read(args)));
            }
        }, delay);
        if (maxWait && !maxWaitHandler.current) {
            maxWaitHandler.current = window.setTimeout(function () {
                var newArgs = maxWaitArgs.current;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current) {
                    debouncedFunction.current.apply(null, newArgs);
                }
            }, maxWait);
        }
    }, [maxWait, delay, cancelDebouncedCallback, leading]);
    var callPending = function () {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) {
            return;
        }
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    };
    // At the moment, we use 3 args array so that we save backward compatibility
    return [debouncedCallback, cancelDebouncedCallback, callPending];
}
//# sourceMappingURL=useDebouncedCallback.js.map